import { mapActions } from 'vuex'

export const BillingPortal = {
  methods: {
    ...mapActions('billingPortal', ['requestBillingPortal']),

    async manageBilling() {
      this.$posthog.capture('manage_billing_link_click')

      try {
        const response = await this.requestBillingPortal()

        if ('url' in response) {
          this.$posthog.capture('manage_billing_end')
          window.location.href = response.url
        }
      } catch (error) {
        this.$posthog.capture('manage_billing_fail')
        console.error(error)
      }
    }
  }
}
